import {SubAPI} from "./SubAPI";
import {Paginated} from "./Users";
import {Cents} from "nate-react-api-helpers";
import {DateString} from "./Projects";

export class QuoteMiscPricing extends SubAPI {
    list(props: {
        project: number
        alternative: number;
        offset: number;
        previewChangeset?: number;
    }) {
        return this.fetcher.get<Paginated<QuoteMiscPrice>>("/api/quote-misc-prices", props)
    }

    upsert(props: Partial<QuoteMiscPrice>) {
        return this.fetcher.post<QuoteMiscPrice>("/api/quote-misc-price", props)
    }

    reOrder(props: {
        project: number;
        alternative?: number;
        idOrder: number[];
    }) {
        return this.fetcher.post("/api/quote-misc-price/reorder", props)
    }

    upsertPreset(props: Partial<MiscPreset>) {
        return this.fetcher.post<MiscPreset>("/api/quote-misc-price/preset", props)
    }

    listPresets(props: {
        offset: number;
        search?: string;
    }) {
        return this.fetcher.get<Paginated<MiscPreset>>("/api/quote-misc-price/presets", props)
    }
}

export type MiscPreset = {
    id: number;
    category: string;
    description: string;
    archived: boolean;
    updatedAt: DateString;
}

export type QuoteMiscPrice = {
    id: number;
    project: number;
    quoteAlternative: number;

    name: string;
    publicNote: string;
    internalNote: string;

    markupPercent?: number;
    markupCents?: Cents;
    unitCostCents: Cents;
    extendedPrice: Cents;

    updatedAt: DateString;
    backup?: QuoteMiscPrice|null;
}